import { render, staticRenderFns } from "./PsicologoProfilePublico.vue?vue&type=template&id=509b066e&scoped=true&"
import script from "./PsicologoProfilePublico.vue?vue&type=script&lang=js&"
export * from "./PsicologoProfilePublico.vue?vue&type=script&lang=js&"
import style0 from "./PsicologoProfilePublico.vue?vue&type=style&index=0&id=509b066e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b066e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAvatar,VCol,VContainer,VDivider,VIcon,VImg,VProgressCircular,VRow})
